module.exports = __webpack_public_path__ + "nc_static/media/refresh.244bc902.svg";